import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'

export const TxDeadlineTooltip = () => {
  const { t } = useTranslation()

  return (
    <TooltipBase>{t('Your transaction will revert if it is left confirming for longer than this time.')}</TooltipBase>
  )
}
